{
    "ExcludeheldtimeLabel": "Vastgehouden tijd uitsluiten:",
    "TalkTime_SectionHeader": "Gesprekstijd",
    "TalkTime_SectionPara": "U kunt kiezen of de gesprekstijdgerelateerde statistieken de wachttijd van het gesprek moeten uitsluiten van de berekeningslogica.",
    "NAME": "TalkTime"
}